import { PICKING_STATE_MAP } from './pickupsConstants';

// Moved to `utils/dates` once the dashboard became the third screen filtering
// by a date range. Re-exported so the pickups imports keep working, and because
// "today" is the pickups window: a picking is a same-day event at the CD, and
// the table is titled "Recogidas del día".
export { toLocalDateString, getTodayRange } from '../../utils/dates';

/**
 * `dd/MM/yyyy HH:mm`, the format the legacy table used for this column.
 *
 * @param {string} value - ISO timestamp
 * @returns {string}
 */
export const formatPickupDate = (value) => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

/**
 * The catalog entry for a print state.
 *
 * A value the catalog does not know is shown as it came, in grey, instead of
 * being folded into "Pendiente" the way the legacy's `mapPickingStatus` does —
 * a state added on the backend should look unfamiliar, not wrong.
 *
 * @param {string} state
 */
export const resolvePickingState = (state) =>
  PICKING_STATE_MAP[state] || { value: state, label: state || '-', color: '#9ca3af' };
